import { Component, OnInit } from '@angular/core';
import { UIRouter, Transition } from "@uirouter/angular";
import { MailboxService } from '../mailbox-service/mailbox.service';
import { CustomerService } from '../customer-service/customer.service';
import { ApiService } from '../api-service/api.service';
import swal from "sweetalert2";

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';



@Component({
  selector: 'app-mailbox-reply',
  templateUrl: './mailbox-reply.component.html',
  styleUrls: ['./mailbox-reply.component.less']
})
export class MailboxReplyComponent implements OnInit {

  public customerPolicies:any
  public customerQuotes:any
  private fromId:number
  public replyEmail: any = {}
  public outboundAddress:string

  constructor(private router: UIRouter, private transition: Transition, 
              private mailboxService : MailboxService,
              private customerService: CustomerService,
              private apiService: ApiService) {
  		  	


  }

  ngOnInit() {

    this.fromId = this.transition.params().fromId

    this.customerService.retrieveCustomerPolicies(this.fromId);

    this.customerService.policies.subscribe((x)=>{
          
      this.customerPolicies = x

      console.log(this.customerPolicies,'Customer policies in overlay');

    })

    this.customerService.retrieveCustomerQuotes(this.fromId);

    this.customerService.quotes.subscribe((x)=>{
          
      this.customerQuotes = x

      console.log(this.customerQuotes,'Customer policies in overlay');

    })

  }
  hideOverlay() {
    this.router.stateService.go('app.mailbox.email')

  }

  sendReply(){

    console.log(this.replyEmail,'Reply')

    var replyItem = {id: this.fromId,
                    message: this.replyEmail.message,
                    cc: this.replyEmail.copyIn,
                    policyCode: this.replyEmail.policy,
                    outboundAddress: this.replyEmail.outboundAddress}


    this.apiService.request('POST', '/customer/nudge', null, replyItem)
    .then((response) => {
      this.hideOverlay();

      swal({
          title: "Message Sent To Customer",   
          type: "success"
      })
    })
    .catch((error)=>{
      console.log(error)
    })
  }

}



// WEBPACK FOOTER //
// /Users/mattspringbett/sites/cycler/apollo-admin/src/src/app/mailbox-reply/mailbox-reply.component.ts